<template>
  <el-container style="height: 600px; border: 1px solid #eee" class="chatContainer" v-loading="gettingChatRooms">
    <el-aside width="300px">
      <ChatRooms @manageRooms="manageTheRooms" @viewRoom="viewRoom"/>
    </el-aside>
    <el-main>
      <div v-if="!manageRooms" v-loading="gettingChatRoom || gettingChatRoomUsers">
        <div v-if="!activeChat.label" class="chatLabel">
          Επιλέξτε συνομιλία από το μενού αριστερά
        </div>
        <div v-else-if="activeChat && activeChat.messages && activeChat.messages.length < 1" class="chatLabel">
          Στείλτε το πρώτο μήνυμα στην συνομιλία {{ activeChat.label }} με τους {{ smallChatMembers }}
        </div>
        <div v-else class="chatLabel">Συνομιλία {{ activeChat.label }} με τους {{ smallChatMembers }}
          <el-pagination
            v-if="activeChat.messages.length <= activeChat.total"
            small
            hide-on-single-page='true'
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :total="activeChat.total"
            background=''
            :current-page.sync="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="10"
            layout='total, sizes, prev, pager, next'
            :page-count="5">
          </el-pagination>
        </div>
        <div v-if="activeChat.label">
          <!-- <el-tooltip class="item" effect="dark" content="Παλαιότερα Μηνύματα" placement="top-start">
            <el-button class="olderMessagesButton" icon="el-icon-caret-top" type="danger" @click="getOlderMessages"></el-button>
          </el-tooltip> -->
          <el-tooltip class="item" effect="dark" content="Ανανέωση Συνομιλίας" placement="top-start">
            <el-button class="refreshButton" type="danger" icon="el-icon-refresh" @click="refreshChat"></el-button>
          </el-tooltip>
        </div>
        <div :class="messageClass(message.username)" v-for="message in activeChatMessages" :key='message.time' v-show="!manageRooms">
          <img :src="imageSrc(message.username)" alt="Avatar" :class="avatarClass(message.username)">
          <span class="messageText">{{ message.text }}</span>
          <div>
            <span class="time-right">
              {{ message.time }}
            </span>
            <span class="time-left">
              Αίτηση: {{ message.app_id}}
              Χρήστης: {{ message.username }}
            </span>
          </div>
        </div>
        <!-- <el-tooltip v-if="activeChat.label" class="item" effect="dark" content="Νεότερα Μηνύματα" placement="top-start">
          <el-button class="newerMessagesButton" icon="el-icon-caret-bottom" type="danger" @click="getNewerMessages"></el-button>
        </el-tooltip> -->
        <div v-show="activeChat.id" v-loading="sendingMessage">
          <el-input
            class="inputAppId"
            placeholder="Αρ. Αίτησης"
            v-model="applicationId">
          </el-input>
          <el-tooltip class="item" effect="dark" content="Αναζήτηση μηνυμάτων σχετιζόμενα με συγκεκριμένη αίτηση" placement="top-start">
            <el-button type="primary" @click="filterAppId">Αναζήτηση</el-button>
          </el-tooltip>
          <div>
            <el-input
              class="inputMessage"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Please input"
              v-model="message">
            </el-input>
            <el-button type="primary" @click="sendMessage">Αποστολή</el-button>
          </div>
        </div>
      </div>
      <manageChatRoom v-if="manageRooms"/>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatRooms from './ChatRooms'
import manageChatRoom from './manageChatRoom'

export default {
  data () {
    return {
      activeChatMessages: {},
      applicationId: '',
      manageRooms: false,
      id: 3,
      message: '',
      perPage: 10,
      currentPage: 1
    }
  },
  components: {
    ChatRooms,
    manageChatRoom
  },
  methods: {
    handleSearchPage (val) {
      this.currentPage = 1
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: val, perPage: this.perPage})
    },
    handleSizeChange (val) {
      this.perPage = val
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage})
    },
    filterAppId () {
      this.$store.dispatch('GET_CHATROOM', {
        id: this.activeChat.id,
        page: this.currentPage,
        perPage: this.perPage,
        appId: parseInt(this.applicationId)
      })
      // this.activeChatMessages = this.activeChat.messages.filter(mes => mes.app_id === parseInt(this.applicationId))
    },
    getNewerMessages () {
      if (this.currentPage > 1) { this.currentPage = this.pacurrentPagege - 1 }
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage})
    },
    getOlderMessages () {
      this.currentPage = this.currentPage + 1
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage})
    },
    refreshChat () {
      this.currentPage = 1
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage, external: this.activeChat.external})
    },
    viewRoom () {
      this.manageRooms = false
    },
    manageTheRooms () {
      this.manageRooms = !this.manageRooms
    },
    sendMessage () {
      // let time = new Date(Date.now())
      // PUT {"message":{"username": "melos2", "time": "2019-12-13 13:48:52", "text": "qqqqq", "app_id": 11   }}"
      if (this.message.length > 1000) {
        this.$notify.warning({
          title: `Προειδοποίηση Ασφάλειας`,
          message: `Δεν μπορείτε να στείλετε μηνύματα μεγαλύτερα από 1000 χαρακτήρες.
            Παρακαλώ σπάστε το σε μικρότερα μηνύματα.`,
          offset: 100,
          duration: 6000
        })
      } else if (this.applicationId === '' && !this.activeChat.external) {
        this.$notify.warning({
          title: `Προσθήκη αριθμού αίτησης`,
          message: `Παρακαλώ βάλτε τον αριθμό της αίτησης που το μήνυμα σας αφορά για να είναι
            εύκολο να εντοπίσετε όλα τα σχετικά με μια αίτηση μηνύματα`,
          offset: 100,
          duration: 10000
        })
      } else {
        this.$store.dispatch('SEND_MESSAGE', {
          // user: {id: this.currentUser.id, name: this.currentUser.name},
          // time: String(time.getHours()) + ':' + String(time.getMinutes()) + ', ' + String(time.getDate()) + '/' + String(time.getMonth() + 1),
          text: this.message,
          app_id: this.applicationId,
          chatId: this.activeChat.id,
          external: this.activeChat.external
        }).then(res => {
          if (res.data) {
            this.message = ''
            this.applicationId = ''
          }
        })
      }
    },
    isItMe (name) {
      return this.currentUser ? name === this.currentUser.name : ''
    },
    avatarClass (name) {
      return this.isItMe(name) ? '' : 'right'
    },
    imageSrc (name) {
      const user = this.currentChatUsers.find(user => user.name === name)
      const avatar = this.currentChatUsers.length > 0 && user
        ? user.avatar
        : null
      return avatar
        ? require('../../../assets/' + avatar + '.jpg')
        : require('../../../assets/whitePone.jpg')
    },
    messageClass (name) {
      return this.isItMe(name) ? 'message darker' : 'message'
    }
  },
  computed: {
    smallChatMembers () {
      return this.chatMembers.length > 100
        ? this.chatMembers.substring(0, 100) + '...'
        : this.chatMembers
    },
    chatMembers () {
      return this.currentChatUsers.map(user => user.name).join(', ')
    },
    ...mapGetters({
      currentUser: 'currentUser',
      activeChat: 'activeChat',
      activeExternalChat: 'activeExternalChat',
      currentChatUsers: 'currentChatUsers',
      gettingChatRoom: 'gettingChatRoom',
      gettingChatRooms: 'gettingChatRooms',
      sendingMessage: 'sendingMessage',
      gettingChatRoomUsers: 'gettingChatRoomUsers',
      myAvatar: 'myAvatar'
    })
  },
  watch: {
    activeChat: function (newData, oldData) {
      this.activeChatMessages = newData.messages
    }
  }
}
</script>

<style lang="scss" scoped>

.newerMessagesButton {
  float: right;
}
.olderMessagesButton {
  float: left;
}

.refreshButton {
  float: right;
}

.messageText {
  word-wrap: break-word;
}

.chatLabel {
  background-color: rgba(64,158,255,.1);
  display: inline-block;
  padding: 0 10px;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  color: #409eff;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(64,158,255,.2);
  white-space: nowrap;
}

.chatContainer {
  text-align: left;
  height: auto;
  padding:0 20px;
}

.inputAppId {
  width: 15%;
  // float: right;
  // margin-left: 30px;
  margin-right:5px;
  padding: 2px;
}

.el-textarea {
  &.inputMessage {
    width: 75%;
  }
}
 /* Chat messages */
.message {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}

/* Darker chat message */
.darker {
  border-color: #ccc;
  background-color: #ddd;
}

/* Clear floats */
.message::after {
  content: "";
  clear: both;
  display: table;
}

/* Style images */
.message img {
  float: left;
  max-width: 20px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
}

/* Style the right image */
.message img.right {
  float: right;
  margin-left: 20px;
  margin-right:0;
}

/* Style time text */
.time-right {
  float: right;
  color: #aaa;
}

/* Style time text */
.time-left {
  // float: left;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/chat/Chat.vue